export const config = {
  NODE_ENV: process.env.NODE_ENV,
  APP_ENV: process.env.REACT_APP_ENV,

  API_URL: process.env.REACT_APP_API_URL,
  APP_URL: `${process.env.REACT_APP_URL}`,
  LOCAL_API_URL: process.env.REACT_APP_LOCAL_API_URL,
};
